<template>
  <div class="kb-tasks">
    <div class="kb-tasks-header">
      <div>
        <h2>知识任务</h2>
        <p>领取任务完成知识贡献，或发布任务邀请同事协作</p>
      </div>
      <Button type="primary" icon="md-add" @click="openPublish">发布任务</Button>
    </div>

    <Tabs v-model="activeTab">
      <TabPane label="任务大厅" name="hall">
        <div class="kb-tasks-toolbar">
          <Select v-model="hallFilter.type" clearable style="width:140px;" placeholder="任务类型">
            <Option value="upload">文档上传</Option>
            <Option value="review">内容审核</Option>
            <Option value="parse">Markdown解析</Option>
            <Option value="rag">RAG同步</Option>
          </Select>
          <Select v-model="hallFilter.reward" clearable style="width:120px;" placeholder="积分">
            <Option value="high">50+</Option>
            <Option value="mid">20-50</Option>
            <Option value="low">20以下</Option>
          </Select>
          <Input v-model="hallFilter.keyword" search placeholder="搜索任务" style="width:220px;" clearable />
        </div>
        <div class="kb-task-grid">
          <div v-for="task in filteredHallTasks" :key="task.id" class="kb-task-card">
            <div class="kb-task-card-top">
              <Tag :color="typeColor(task.type)">{{ typeText(task.type) }}</Tag>
              <span class="kb-task-reward"><BaseIcon icon="md-trophy" :size="14" /> {{ task.reward }} 积分</span>
            </div>
            <h3 class="kb-task-title">{{ task.title }}</h3>
            <p class="kb-task-desc">{{ task.desc }}</p>
            <div class="kb-task-meta">
              <span>发布：{{ task.publisher }}</span>
              <span>截止：{{ task.deadline }}</span>
              <span>名额 {{ task.claimed }}/{{ task.quota }}</span>
            </div>
            <div class="kb-task-card-footer">
              <Button
                type="primary"
                :disabled="!canClaim(task)"
                @click="claimTask(task)"
              >{{ task.claimed >= task.quota ? '已满' : '领取任务' }}</Button>
            </div>
          </div>
          <BaseEmpty v-if="filteredHallTasks.length === 0" type="empty" msg="暂无匹配任务" />
        </div>
      </TabPane>
      <TabPane label="我发布的" name="published">
        <Table :columns="publishedColumns" :data="publishedTasks" stripe size="small">
          <template slot-scope="{ row }" slot="status">
            <Tag :color="taskStatusColor(row.status)">{{ taskStatusText(row.status) }}</Tag>
          </template>
          <template slot-scope="{ row }" slot="action">
            <Button type="text" size="small" @click="viewPublished(row)">查看</Button>
            <Button
              v-if="row.status === 'open'"
              type="text"
              size="small"
              @click="closeTask(row)"
            >关闭</Button>
          </template>
        </Table>
      </TabPane>
    </Tabs>

    <Modal v-model="showPublish" title="发布任务" footer-hide width="560">
      <Form :model="publishForm" :label-width="90">
        <FormItem label="任务标题">
          <Input v-model="publishForm.title" placeholder="请输入任务标题" />
        </FormItem>
        <FormItem label="任务类型">
          <Select v-model="publishForm.type">
            <Option value="upload">文档上传</Option>
            <Option value="review">内容审核</Option>
            <Option value="parse">Markdown解析</Option>
            <Option value="rag">RAG同步</Option>
          </Select>
        </FormItem>
        <FormItem label="任务描述">
          <Input v-model="publishForm.desc" type="textarea" :rows="4" placeholder="说明任务要求与交付标准" />
        </FormItem>
        <FormItem label="奖励积分">
          <InputNumber v-model="publishForm.reward" :min="5" :max="500" style="width:120px;" />
        </FormItem>
        <FormItem label="领取名额">
          <InputNumber v-model="publishForm.quota" :min="1" :max="50" style="width:120px;" />
        </FormItem>
        <FormItem label="截止日期">
          <DatePicker v-model="publishForm.deadline" type="date" placeholder="选择日期" style="width:100%;" />
        </FormItem>
      </Form>
      <div class="kb-publish-footer">
        <Button @click="showPublish = false">取消</Button>
        <Button type="primary" @click="submitPublish">发布</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/Icon';
import BaseEmpty from '@/components/base/Empty';

export default {
  components: {BaseIcon, BaseEmpty},
  data() {
    return {
      activeTab: 'hall',
      showPublish: false,
      hallFilter: {type: '', reward: '', keyword: ''},
      publishForm: {
        title: '',
        type: 'upload',
        desc: '',
        reward: 30,
        quota: 3,
        deadline: null,
      },
      hallTasks: [
        {id: 1, title: '补充 BIM 协同操作手册', type: 'upload', desc: '上传或完善 BIM 协同相关文档，需包含操作截图', reward: 50, publisher: '项目管理办', deadline: '2026-05-25', quota: 2, claimed: 0, status: 'open'},
        {id: 2, title: '审核安全手册第三章', type: 'review', desc: '对安全手册第三章内容进行合规性审核', reward: 25, publisher: '质量安全部', deadline: '2026-05-20', quota: 1, claimed: 1, status: 'open'},
        {id: 3, title: 'PDF 规范文档 Markdown 解析', type: 'parse', desc: '将技术规范目录下 3 份 PDF 完成 Markdown 摘要解析', reward: 40, publisher: '技术中心', deadline: '2026-05-22', quota: 3, claimed: 2, status: 'open'},
        {id: 4, title: '合同模板库 RAG 向量同步', type: 'rag', desc: '完成合同模板目录全部文件的 RAG 上传与校验', reward: 60, publisher: '法务合规部', deadline: '2026-05-28', quota: 1, claimed: 0, status: 'open'},
        {id: 5, title: '整理培训视频元数据', type: 'upload', desc: '为培训视频补充标题、标签与简介', reward: 15, publisher: '人力资源部', deadline: '2026-05-18', quota: 5, claimed: 3, status: 'open'},
      ],
      publishedTasks: [],
      publishedColumns: [
        {title: '任务', key: 'title', minWidth: 180},
        {title: '类型', key: 'typeLabel', width: 110},
        {title: '积分', key: 'reward', width: 70},
        {title: '进度', key: 'progressLabel', width: 90},
        {title: '截止', key: 'deadline', width: 110},
        {title: '状态', slot: 'status', width: 90},
        {title: '操作', slot: 'action', width: 120},
      ],
      myClaimedIds: [],
    };
  },
  mounted() {
    this.publishedTasks = [
      this.formatPublishedRow({id: 101, title: '更新 Vue3 组件规范', type: 'upload', reward: 35, quota: 2, claimed: 1, deadline: '2026-05-30', status: 'open'}),
      this.formatPublishedRow({id: 102, title: '项目案例目录整理', type: 'upload', reward: 20, quota: 1, claimed: 1, deadline: '2026-05-15', status: 'closed'}),
    ];
    this.loadClaimedIds();
  },
  computed: {
    filteredHallTasks() {
      return this.hallTasks.filter((t) => {
        if (t.status !== 'open') return false;
        if (this.hallFilter.type && t.type !== this.hallFilter.type) return false;
        if (this.hallFilter.keyword && !t.title.includes(this.hallFilter.keyword)) return false;
        if (this.hallFilter.reward === 'high' && t.reward < 50) return false;
        if (this.hallFilter.reward === 'mid' && (t.reward < 20 || t.reward > 50)) return false;
        if (this.hallFilter.reward === 'low' && t.reward >= 20) return false;
        return true;
      });
    },
  },
  methods: {
    typeText(type) {
      return {upload: '文档上传', review: '内容审核', parse: 'Markdown解析', rag: 'RAG同步'}[type] || type;
    },
    typeColor(type) {
      return {upload: 'blue', review: 'orange', parse: 'green', rag: 'purple'}[type] || 'default';
    },
    taskStatusText(s) {
      return {open: '进行中', closed: '已关闭'}[s] || s;
    },
    taskStatusColor(s) {
      return {open: 'success', closed: 'default'}[s] || 'default';
    },
    canClaim(task) {
      return task.claimed < task.quota && !this.myClaimedIds.includes(task.id);
    },
    claimTask(task) {
      if (!this.canClaim(task)) return;
      task.claimed += 1;
      this.myClaimedIds.push(task.id);
      this.$Message.success(`已领取：${task.title}`);
      this.syncMyTasks(task);
      this.$Modal.confirm({
        title: '领取成功',
        content: '是否前往「我的」查看任务进度？',
        onOk: () => this.RouteTo('/core/knowledge/mine?tab=tasks'),
      });
    },
    storageKey() {
      return 'kb-my-tasks';
    },
    loadClaimedIds() {
      try {
        const list = JSON.parse(localStorage.getItem(this.storageKey()) || '[]');
        this.myClaimedIds = list.map((t) => t.id);
      } catch (e) {
        this.myClaimedIds = [];
      }
    },
    syncMyTasks(task) {
      let list = [];
      try {
        list = JSON.parse(localStorage.getItem(this.storageKey()) || '[]');
      } catch (e) {
        list = [];
      }
      if (!list.find((t) => t.id === task.id)) {
        list.push({
          id: task.id,
          title: task.title,
          type: task.type,
          typeLabel: this.typeText(task.type),
          reward: task.reward,
          deadline: task.deadline,
          status: 'in_progress',
          progress: 0,
        });
        localStorage.setItem(this.storageKey(), JSON.stringify(list));
      }
    },
    formatPublishedRow(row) {
      return {
        ...row,
        typeLabel: this.typeText(row.type),
        progressLabel: `${row.claimed}/${row.quota}`,
      };
    },
    openPublish() {
      this.publishForm = {title: '', type: 'upload', desc: '', reward: 30, quota: 3, deadline: null};
      this.showPublish = true;
    },
    submitPublish() {
      if (!this.publishForm.title) {
        this.$Message.warning('请输入任务标题');
        return;
      }
      let deadline = '—';
      if (this.publishForm.deadline) {
        const d = new Date(this.publishForm.deadline);
        deadline = isNaN(d.getTime()) ? String(this.publishForm.deadline) : d.toISOString().slice(0, 10);
      }
      const row = {
        id: Date.now(),
        title: this.publishForm.title,
        type: this.publishForm.type,
        reward: this.publishForm.reward,
        quota: this.publishForm.quota,
        claimed: 0,
        deadline,
        status: 'open',
      };
      this.publishedTasks.unshift(this.formatPublishedRow(row));
      this.hallTasks.unshift({
        ...row,
        desc: this.publishForm.desc || '—',
        publisher: '我',
      });
      this.showPublish = false;
      this.$Message.success('任务发布成功');
      this.activeTab = 'published';
    },
    viewPublished(row) {
      this.$Message.info(`任务「${row.title}」：${row.claimed}/${row.quota} 人已领取`);
    },
    closeTask(row) {
      row.status = 'closed';
      const hall = this.hallTasks.find((t) => t.id === row.id);
      if (hall) hall.status = 'closed';
      this.$Message.success('任务已关闭');
    },
  },
};
</script>

<style lang="less" scoped>
.kb-tasks {
  height: 100%;
  overflow: auto;
  padding: 24px 32px;
  background: var(--bg2);
}

.kb-tasks-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 16px;

  h2 {
    margin: 0 0 4px;
    font-size: 20px;
  }

  p {
    margin: 0;
    font-size: 13px;
    color: var(--subtext2);
  }
}

.kb-tasks-toolbar {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.kb-task-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.kb-task-card {
  background: var(--bg3);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px 18px;
  transition: box-shadow 0.2s, border-color 0.2s;

  &:hover {
    border-color: rgba(51, 153, 255, 0.4);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  }

  .kb-task-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .kb-task-reward {
    font-size: 13px;
    font-weight: 600;
    color: #fa8c16;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .kb-task-title {
    margin: 0 0 8px;
    font-size: 15px;
    line-height: 1.4;
  }

  .kb-task-desc {
    margin: 0 0 12px;
    font-size: 12px;
    color: var(--subtext2);
    line-height: 1.5;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .kb-task-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 11px;
    color: var(--subtext3);
    margin-bottom: 14px;
  }

  .kb-task-card-footer {
    border-top: 1px solid var(--border);
    padding-top: 12px;
  }
}

.kb-publish-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}
</style>
